<template>
    <footer class="relative w-full py-10 px-10 bg-primary-focus mt-20 box-border text-white">
        <!-- Font use: https://fonts.adobe.com/fonts/bc-alphapipe -->
        <!-- Font use: https://fonts.adobe.com/fonts/poppins -->
        <!-- Icons taken from: https://heroicons.com -->

        <span>Copyright 2023 - Wiebe Ranzijn</span>
    </footer>
</template>
